import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Home from './views/Home.vue'

Vue.use(Meta)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/interview/mizutamari-bond',
      name: 'スペシャルインタビュー 水溜りボンド',
      component: () =>
        import(/* webpackChunkName: "interview" */ './views/Interview.vue')
    },
    {
      path: '/interview/tokido',
      name: 'スペシャルインタビュー ときど',
      component: () =>
        import(
          /* webpackChunkName: "interviewTokido" */ './views/InterviewTokido.vue'
        )
    },
    {
      path: '/interview/mishina',
      name: 'スペシャルインタビュー 三科光平',
      component: () =>
        import(
          /* webpackChunkName: "interviewMishina" */ './views/InterviewMishina.vue'
        )
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 100)
      })
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 100)
      })
    }
  }
})
export default router
